export * from './GetDuration';
export * from './Roles';
export * from './CapitalizeFirstLetter';



// WEBPACK FOOTER //
// ./src/methods/index.js